module.exports = __webpack_public_path__ + "static/Setmore-c298c651482db1098e21bd52698a7bbe.svg";